var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNok = function SvgNok(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1544_2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 39.9999C31.0462 39.9999 40.0005 31.0456 40.0005 19.9999C40.0005 8.95418 31.0462 -0.00012207 20.0005 -0.00012207C8.95479 -0.00012207 0.000488281 8.95418 0.000488281 19.9999C0.000488281 31.0456 8.95479 39.9999 20.0005 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 25.2174C1.84615 29.5111 4.39654 33.2325 7.82607 35.8676V25.2174H0.688965Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2607 39.9239C18.834 39.9733 19.4138 40 19.9999 40C29.2404 40 37.0159 33.7327 39.3109 25.2174H18.2607V39.9239Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3109 14.7826C37.0159 6.26726 29.2404 0 19.9999 0C19.4138 0 18.834 0.0267187 18.2607 0.0760937V14.7826H39.3109Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82607 4.13245C4.39654 6.7676 1.84615 10.4889 0.688965 14.7826H7.82607V4.13245Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3913H15.6523H15.6522V0.475342C13.8039 0.885185 12.0516 1.54948 10.4348 2.43175V17.3911V17.3912H0.169297C0.0579688 18.2452 0 19.1158 0 19.9999C0 20.8841 0.0579688 21.7547 0.169297 22.6086H10.4347H10.4348V37.5681C12.0516 38.4503 13.8039 39.1147 15.6522 39.5245V22.6089V22.6087H39.8307C39.9419 21.7547 40 20.8841 40 19.9999C40 19.1158 39.9419 18.2452 39.8307 17.3913Z",
    fill: "#0052B4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1544_2375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "NOK.c8ce10d69089ba23305c879248ab13c9.svg";